import { SubmitHandler } from "react-hook-form";

import { useTeamContext } from "../contexts/Team";
import { IClubhouseTeamInfoData } from "../types/team";

import { alertActions } from "../../../../../features/alert/alertSlice";
import { useAppDispatch } from "../../../../../hooks/reduxHooks";
import { updateTeam } from "../../../../../lib/api";

const useFormHandlers = () => {
    const {
        team,
        fileList,
        setTeam,
        setFileList,
        formMethods: methods,
        setAsyncStatus,
    } = useTeamContext();
    const dispatch = useAppDispatch();

    const handleSubmit: SubmitHandler<IClubhouseTeamInfoData> = async data => {
        setAsyncStatus("pending");
        data.files = fileList;

        await updateTeam(team!.id, data)
            .then(response => {
                dispatch(
                    alertActions.success({
                        title: `Team updated successfully`,
                        dismissible: true,
                    }),
                );

                setTeam(response.team);
                setFileList([]);
                methods.resetField("files");
                setAsyncStatus("success");
            })
            .catch(e => {
                dispatch(
                    alertActions.error({
                        title: `The server encountered a problem updating the team.`,
                        text: "If the problem continues, please reach out to an admin.",
                        dismissible: true,
                    }),
                );
                setAsyncStatus("failed");
            });
    };

    return { handleSubmit };
};

export default useFormHandlers;
